import * as csv from "lib/csv";

const parseJson = function(string) {
    let data;
    try {
        data = string.split("\n").map(function(r) {
            return r ? JSON.parse(r) : null;
        }).filter(function(r) {
            return r;
        });
    } catch (e_) {
        //skip
    }

    return data;
};

export default function parseFile(rawData) {
    let parsed = null;
    try {
        let firstRow = rawData.slice(0, rawData.indexOf("\n"));
        JSON.parse(firstRow);
        parsed = parseJson(rawData);
    } catch (err) {
        parsed = csv.parse(rawData);
    }

    return parsed;
}


// WEBPACK FOOTER //
// ./src/lib/parseFile.js